import { filterOperators } from './operators';

export const NAME_CONTAINS_ANY_OPERATOR = 'name containsAny' as const;
export type NameContainsAnyOperator = typeof NAME_CONTAINS_ANY_OPERATOR;

export const NAME_NOT_CONTAINS_ANY_OPERATOR = 'name notContainsAny' as const;
export type NameNotContainsAnyOperator = typeof NAME_NOT_CONTAINS_ANY_OPERATOR;

export const isArrayContainsOperator = (
  operator: string | null | undefined,
): operator is (typeof filterOperators.arrayContains)[number] =>
  operator !== null &&
  operator !== undefined &&
  (filterOperators.arrayContains as readonly string[]).includes(operator);

export const isNameContainsAnyOperator = (
  operator: string | null | undefined,
): operator is NameContainsAnyOperator =>
  operator === NAME_CONTAINS_ANY_OPERATOR;

export const isNameNotContainsAnyOperator = (
  operator: string | null | undefined,
): operator is NameNotContainsAnyOperator =>
  operator === NAME_NOT_CONTAINS_ANY_OPERATOR;

export const isLabelsNameOperator = (
  operator: string | null | undefined,
): boolean =>
  isNameContainsAnyOperator(operator) || isNameNotContainsAnyOperator(operator);

export const isLabelsArrayOperator = (
  operator: string | null | undefined,
): boolean =>
  operator === 'containsAny' ||
  operator === 'notContainsAny' ||
  isLabelsNameOperator(operator);

export const serializeArrayContainsFilterValue = (values: string[]): string =>
  values.join(', ');

export const parseArrayContainsFilterValue = (value: string): string[] =>
  value
    .split(/,\s*/)
    .map((part) => part.trim())
    .filter((part) => part !== '');
